// extracted by mini-css-extract-plugin
export default {"courseOverviewListSection":"CourseOverviewListSection_courseOverviewListSection__AFiBE","sectionList":"CourseOverviewListSection_sectionList__IyDp9"};